// The externally generated age gate can be inserted or translated after load.
// Associate its existing localized text without changing submission behavior.
export function init() {
	function labelControls() {
		document.querySelectorAll('.age-gate_input[title]').forEach((input) => {
			if (!input.hasAttribute('aria-label')) {
				input.setAttribute('aria-label', input.getAttribute('title'));
			}
		});

		const controls = [
			['.agegate_noAgeInputCheckbox input', 'agegate-confirm-age'],
			['.agegate_rememberMe input[name="rememberMe"]', 'agegate-remember-me'],
			['select#agegate_change_country', 'agegate_change_country'],
		];
		controls.forEach(([selector, id]) => {
			const control = document.querySelector(selector);
			if (!control || control.labels?.length) return;
			const parent = control.parentElement;
			const textNodes = Array.from(parent.childNodes).filter((node) =>
				(node.nodeType === Node.TEXT_NODE && node.textContent.trim()) ||
				(node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'SPAN')
			);
			if (!textNodes.length) return;
			control.id = control.id || id;
			const label = document.createElement('label');
			label.htmlFor = control.id;
			parent.insertBefore(label, textNodes[0]);
			textNodes.forEach((node) => label.appendChild(node));
		});
	}
	labelControls();
	new MutationObserver(labelControls).observe(document.body, {
		childList: true,
		subtree: true,
	});
}
